import React from 'react'
import { WaitSpinner } from '@energytoolbase/components'
import styled from 'styled-components'

const SpinnerDiv = styled.div`
  height: 100vh;
`

export function FullScreenSpinner(): JSX.Element {
  return <WaitSpinner blocking children={[<SpinnerDiv key='spinner' />]} />
}
